import { render, staticRenderFns } from "./Flexbox.vue?vue&type=template&id=81e70d72&"
import script from "./Flexbox.vue?vue&type=script&lang=js&"
export * from "./Flexbox.vue?vue&type=script&lang=js&"
import style0 from "./Flexbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports